import '../../chunks/react/parent/fragmentElement.module.CXwebMu0.css';const module = {
  "fragment-element": "_fragment-element_1gxyo_1",
  "fragment-element_layout_flex-contain": "_fragment-element_layout_flex-contain_1gxyo_6"
};
export {
  module as m
};
//# sourceMappingURL=fragmentElement.module.css.js.map
